import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import GastosPorCategoria from '../views/GastosPorCategoria.vue';
import GastosPorMes from '../views/GastosPorMes.vue';
import GastosPorAno from '../views/GastosPorAno.vue';
import Suscripciones from '../views/Suscripciones.vue';
import Resumen from '../views/Resumen.vue';
import Categorias from '../views/Categorias.vue';
import Perfil from '../views/Perfil.vue';
import Grupo from '../views/Grupo.vue';
import GastosPlanificados from '../views/GastosPlanificados.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import Registro from '../views/Registro.vue';
import Admin from '../views/Admin.vue';
import Evolucion from '../views/Evolucion.vue';
import Nutricion from '../views/Nutricion.vue';
import Tareas from '../views/Tareas.vue';
import Peliculas from '../views/Peliculas.vue';
import Ingresos from '../views/Ingresos.vue';
import Salud from '../views/Salud.vue';
import SaludOura from '../views/SaludOura.vue';
import OuraAnalisis from '../views/OuraAnalisis.vue';
import SaludFitDays from '../views/SaludFitDays.vue';
import SaludCoros from '../views/SaludCoros.vue';
import SaludTrainingPeaks from '../views/SaludTrainingPeaks.vue';
import CalculadoraFirePage from '../views/CalculadoraFirePage.vue';
import FiCripto from '../views/FiCripto.vue';
import Wallet from '../views/Wallet.vue';
import CriptoMcp from '../views/CriptoMcp.vue';
import MyLife from '../views/MyLife.vue';
import Inspiracion from '../views/Inspiracion.vue';
import Recetas from '../views/Recetas.vue';
import ListaCompra from '../views/ListaCompra.vue';
import GmailInbox from '../views/GmailInbox.vue';
import SeguimientoPedidos from '../views/SeguimientoPedidos.vue';
import Informes from '../views/Informes.vue';
import MiDia from '../views/MiDia.vue';
import Privacidad from '../views/Privacidad.vue';
import EliminarCuenta from '../views/EliminarCuenta.vue';
import store from '../store';
import { debeAbrirNuevoGasto, esRedirectInterno, esNotificacionGasto } from '../utils/atajoPwa';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/nuevo-gasto',
    name: 'NuevoGasto',
    component: Home,
    meta: { requiresAuth: true, abrirFormulario: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/recuperar-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/resetear-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/registro',
    name: 'Registro',
    component: Registro
  },
  {
    path: '/privacidad',
    name: 'Privacidad',
    component: Privacidad
  },
  {
    path: '/informes',
    name: 'Informes',
    component: Informes,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/eliminar-cuenta',
    name: 'EliminarCuenta',
    component: EliminarCuenta
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/evolucion',
    name: 'Evolucion',
    component: Evolucion,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/gastos-por-categoria',
    name: 'GastosPorCategoria',
    component: GastosPorCategoria,
    meta: { requiresAuth: true }
  },
  {
    path: '/gastos-por-mes',
    name: 'GastosPorMes',
    component: GastosPorMes,
    meta: { requiresAuth: true }
  },
  {
    path: '/gastos-por-ano',
    name: 'GastosPorAno',
    component: GastosPorAno,
    meta: { requiresAuth: true }
  },
  {
    path: '/suscripciones',
    name: 'Suscripciones',
    component: Suscripciones,
    meta: { requiresAuth: true }
  },
  {
    path: '/resumen',
    name: 'Resumen',
    component: Resumen,
    meta: { requiresAuth: true }
  },
  {
    path: '/categorias',
    name: 'Categorias',
    component: Categorias,
    meta: { requiresAuth: true }
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: Perfil,
    meta: { requiresAuth: true }
  },
  {
    path: '/grupo',
    name: 'Grupo',
    component: Grupo,
    meta: { requiresAuth: true }
  },
  {
    path: '/gastos-planificados',
    name: 'GastosPlanificados',
    component: GastosPlanificados,
    meta: { requiresAuth: true }
  },
  {
    path: '/nutricion',
    name: 'Nutricion',
    component: Nutricion,
    meta: { requiresAuth: true }
  },
  {
    path: '/recetas',
    name: 'Recetas',
    component: Recetas,
    meta: { requiresAuth: true }
  },
  {
    path: '/lista-compra',
    name: 'ListaCompra',
    component: ListaCompra,
    meta: { requiresAuth: true }
  },
  {
    path: '/tareas',
    name: 'Tareas',
    component: Tareas,
    meta: { requiresAuth: true }
  },
  {
    path: '/peliculas',
    name: 'Peliculas',
    component: Peliculas,
    meta: { requiresAuth: true }
  },
  {
    path: '/ingresos',
    name: 'Ingresos',
    component: Ingresos,
    meta: { requiresAuth: true }
  },
  {
    path: '/calculadora-fire',
    name: 'CalculadoraFire',
    component: CalculadoraFirePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/salud',
    name: 'Salud',
    component: Salud,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/salud-oura',
    name: 'SaludOura',
    component: SaludOura,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/analisis-oura',
    name: 'OuraAnalisis',
    component: OuraAnalisis,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/salud-fitdays',
    name: 'SaludFitDays',
    component: SaludFitDays,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/salud-coros',
    name: 'SaludCoros',
    component: SaludCoros,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/salud-trainingpeaks',
    name: 'SaludTrainingPeaks',
    component: SaludTrainingPeaks,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/fi-cripto',
    name: 'FiCripto',
    component: FiCripto,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: Wallet,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/cripto-mcp',
    name: 'CriptoMcp',
    component: CriptoMcp,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/my-life',
    name: 'MyLife',
    component: MyLife,
    meta: { requiresAuth: true }
  },
  {
    path: '/inspiracion',
    name: 'Inspiracion',
    component: Inspiracion,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/gmail',
    name: 'GmailInbox',
    component: GmailInbox,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/mi-dia',
    name: 'MiDia',
    component: MiDia,
    meta: { requiresAuth: true }
  },
  {
    path: '/seguimiento',
    name: 'SeguimientoPedidos',
    component: SeguimientoPedidos,
    meta: { requiresAuth: true, requiresAdmin: true }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

/** Comprueba si el usuario puede abrir la ruta de vista por defecto */
function puedeAbrirVistaInicio(vista) {
  if (!vista || vista === '/') return true;
  if (vista === '/evolucion' || vista === '/admin' || vista === '/salud' || vista === '/salud-oura' || vista === '/analisis-oura' || vista === '/salud-fitdays' || vista === '/salud-coros' || vista === '/salud-trainingpeaks' || vista === '/fi-cripto' || vista === '/wallet' || vista === '/cripto-mcp' || vista === '/inspiracion' || vista === '/gmail' || vista === '/seguimiento') {
    return store.getters['auth/isAdmin'];
  }
  if (vista === '/ingresos') {
    return store.getters['auth/hasIngresos'];
  }
  return true;
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/isAuthenticated']) {
      console.log('No hay token, redirigiendo a login');
      next({ path: '/login', query: { redirect: to.fullPath } });
      return;
    }
  }

  // Al abrir la app en la raíz (PWA, móvil, marcador): ir a la vista por defecto del perfil
  // Solo en la primera navegación (from sin rutas resueltas); si el usuario elige "Gastos" en el menú, from ya tiene matched
  if (
    to.path === '/' &&
    store.getters['auth/isAuthenticated'] &&
    from.matched.length === 0 &&
    !debeAbrirNuevoGasto(to) &&
    !esNotificacionGasto(to)
  ) {
    const vista = store.getters['auth/vistaInicio'] || '/';
    if (vista !== '/' && puedeAbrirVistaInicio(vista)) {
      next(vista);
      return;
    }
  }

  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (!store.getters['auth/isAdmin']) {
      console.log('No es admin, redirigiendo a home');
      next('/');
      return;
    }
  }
  
  if (to.path === '/login' && store.getters['auth/isAuthenticated']) {
    if (esRedirectInterno(to.query.redirect)) {
      next(to.query.redirect);
      return;
    }
    const vista = store.getters['auth/vistaInicio'] || '/';
    console.log('Usuario ya autenticado, redirigiendo a vista por defecto');
    next(puedeAbrirVistaInicio(vista) && vista !== '/login' ? vista : '/');
    return;
  }
  
  next();
});

export default router; 